import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import TextInputComponent from '@components/textInput/TextInput'

import theme from '@theme/Theme'
import useI18n from '@i18n/useI18n'
import useNavigation from '@layout/useNavigation'

type IncidentListHeaderMobile = {
  onSwitchView: () => void
  exportIncidents: () => void
  setSearch: (text: string) => void
  searchText: string
  onLeft?: () => void
  displayExport: boolean
  exportStatus?: ButtonStatus
}

const IncidentListHeaderMobile = ({
  onSwitchView,
  exportIncidents,
  setSearch,
  searchText,
  onLeft,
  displayExport,
  exportStatus,
}: IncidentListHeaderMobile) => {
  const i18n = useI18n()
  const navigation = useNavigation()

  return (
    <MainContainer>
      <ContentContainer>
        <LeftButton activeOpacity={0.9} onPress={onLeft || (() => navigation.goBack())}>
          <Icon name="arrow-left" size={35} color={theme.colors.background} />
        </LeftButton>

        <Title>{i18n.t('screens.incidentList.linkTitle')}</Title>
        <RightContainer>
          <ButtonContainer>
            <MapButton activeOpacity={0.9} onPress={onSwitchView}>
              <Icon name="map" size={25} color={theme.colors.primary} />
            </MapButton>
            {displayExport && (
              <TouchableOpacity activeOpacity={0.9} onPress={exportIncidents} disabled={exportStatus !== 'active'}>
                <Icon name="download" size={25} color={theme.colors.background} />
              </TouchableOpacity>
            )}
          </ButtonContainer>
        </RightContainer>
      </ContentContainer>
      <SubHearder>
        <TextInputComponent
          onChange={setSearch}
          searchStyle="onDark"
          placeholder={i18n.t('screens.incidentList.search')}
          left={{ name: 'search' }}
          value={searchText}
        />
      </SubHearder>
    </MainContainer>
  )
}

export default IncidentListHeaderMobile

const MainContainer = styled(View)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.primary};
`

const ContentContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  height: 30px;
  margin-top: ${(props) => props.theme.insets.top}px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => props.theme.colors.background};
  flex: 2;
  text-align: center;
`
const RightContainer = styled(View)`
  flex: 1;
  align-items: flex-end;
`
const LeftButton = styled(TouchableOpacity)`
  flex: 1;
  align-items: flex-start;
`

const MapButton = styled(TouchableOpacity)`
  height: 35px;
  width: 35px;
  border-radius: 35px;
  background-color: ${(props) => props.theme.colors.background};
  justify-content: center;
  align-items: center;
`
const ButtonContainer = styled(View)`
  width: 80px;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`

const SubHearder = styled(View)`
  margin-top: 20px;
`
